import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const AUTO_GLASS_FAQS = [{
  question: 'Do you offer windshield replacement near me?',
  answer: "Kosin's Glass serves Howell, Ann Arbor, Novi and many surrounding Southeast Michigan communities. Request a quote and the team will confirm availability for your vehicle and location."
}, {
  question: "Can Kosin's help with insurance?",
  answer: "Yes. Kosin's Glass works with most insurance companies and can help with quote details, claim coordination and scheduling."
}, {
  question: 'Do I need ADAS calibration after windshield replacement?',
  answer: "If your vehicle has a forward-facing camera or sensor mounted near the windshield, calibration may be required after replacement. Kosin's Glass offers on-site ADAS recalibration."
}, {
  question: 'Can a windshield chip be repaired?',
  answer: "Some small chips may be repairable, especially when they're away from the driver's line of sight and the windshield edge. Spreading cracks usually require replacement."
}, {
  question: 'Do you replace side windows, door glass and rear windows?',
  answer: "Yes. Kosin's Glass replaces side windows, driver and passenger door glass, quarter glass and rear windows for most makes and models."
}, {
  question: 'Do you repair truck and semi truck glass?',
  answer: "Yes. Kosin's Glass services truck windshields, semi truck glass, commercial truck glass and offers fleet account options."
}, {
  question: 'Is same-day auto glass service available?',
  answer: 'Same-day openings may be available depending on the vehicle, glass availability and schedule. Call the Howell Auto Glass Service Center to check availability.'
}];
export function AutoGlassFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-16 lg:py-24 bg-white" data-id="element-394" data-mp="1wxk1c6w9zr23">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-395" data-mp="1wyv36165uoqk">
        <div className="text-center mb-12" data-id="element-396" data-mp="uknhu7foxitc">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-397" data-mp="uhsyykcbs621">
            Auto Glass Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-398" data-mp="13jsflbjfh84g">
          {AUTO_GLASS_FAQS.map((item, idx) => {
          const isOpen = openIdx === idx;
          const panelId = `auto-faq-panel-${idx}`;
          const buttonId = `auto-faq-button-${idx}`;
          return <div key={idx} className={`border rounded-lg transition-colors ${isOpen ? 'border-brandBlue-200 bg-brandBlue-50/30' : 'border-slate-200 bg-white'}`} data-id="element-399" data-mp="1dc7xk8uq5wpc" data-mpi={idx}>
                <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brandBlue-500 rounded-lg" data-id="element-400" data-mp="1m8z5pjmjx20a">
                  <span className="text-lg font-bold text-navy-900 pr-8" dangerouslySetInnerHTML={{
                __html: item.question
              }} data-id="element-401" data-mp="3gqidrqo21ghh" />
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-brandBlue-600' : 'text-slate-400'}`} aria-hidden="true" data-id="element-402" data-mp="36u5joroll0m7" />
                </button>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-403" data-mp="3uhvukwukw08t">
                  <div className="overflow-hidden" data-id="element-404" data-mp="2f1wpxvk66mdb">
                    <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed" dangerouslySetInnerHTML={{
                  __html: item.answer
                }} data-id="element-405" data-mp="2f03iwf5na04s" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}